const iconsMap = {
    'check': 'icon-check',
    'retry': 'icon-arrow3',
}

export const TelegramIcon = () => <i className="icon-tg"></i>
export const InstagramIcon = () => <i className="icon-inst"></i>
export const VkontakteIcon = () => <i className="icon-vk"></i>
export const MaxIcon = () => <i className="icon-max"></i>
export const EmailIcon = () => <i className="icon-mail4"></i>
export const WhatsAppIcon = () => <i className="icon-wa"></i>
export const ThreadsIcon = () => <i className="icon-threads"></i>
export const YoutubeIcon = () => <i className="icon-yt"></i>
export const RythmIcon = () => <i className="icon-yar"></i>
export const DzenIcon = () => <i className="icon-dzen"></i>
export const LinkedInIcon = () => <i className="icon-linked"></i>

export const SocialIcon = ({type}) =>
{
    switch ( type )
    {
        case 'telegram': return <TelegramIcon/>
        case 'telegram_channel': return <TelegramIcon/>
        case 'instagram': return <InstagramIcon/>
        case 'vkontakte': return <VkontakteIcon/>
        case 'max': return <MaxIcon/>
        case 'email': return <EmailIcon/>
        case 'whatsapp': return <WhatsAppIcon/>
        case 'threads': return <ThreadsIcon/>
        case 'youtube': return <YoutubeIcon/>
        case 'rythm': return <RythmIcon/>
        case 'dzen': return <DzenIcon/>
        case 'linkedin': return <LinkedInIcon/>
        // MORE ICONS HERE...
        default: {
            console.error('Unknown icon type: ' + type);
            return null;
        }
    }
}

export const Icon = ({type, className = undefined}) => {
    const foundIcon = iconsMap[type] || null

    if (!foundIcon) 
        return null

    return <i className={cn(foundIcon, className)}></i>
}
